import { Platform } from "react-native";
export const FontAwesomeKitIcon = ({ size = 14, color = "#fff", style = "solid", name, cssStyle, }) => {
    if (Platform.OS === "web") {
        return (<i style={{ fontSize: size, color: color, ...(cssStyle ?? {}) }} className={`fa-${style} fa-${name}`}/>);
    }
    return null;
};
//# sourceMappingURL=FontAwesomeKitIcon.js.map